<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="$t('用户')" prop="userId" >
        <a-select
          show-search
          option-filter-prop="label"
          :filter-option="false"
          :not-found-content="userFetching ? undefined : null"
          v-model="form.userId"
          :placeholder="$t('搜索用户昵称或ID选择')"
          @search="fetchUser"
          @focus="fetchUser('')"
        >
          <a-spin v-if="userFetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="u in userOptions" :key="u.value" :value="u.value" :label="u.label">
            {{ u.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('账户类型')" prop="type" >
        <a-select v-model="form.type" :placeholder="$t('请选择账户类型')">
          <a-select-option value="bank">{{ $t('银行卡') }}</a-select-option>
          <a-select-option value="paypal">paypal</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('持卡人姓名')" prop="realName" >
        <a-input v-model="form.realName" :maxLength="256" :placeholder="$t('请输入') + $t('持卡人姓名')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('银行名称')" prop="bankName" >
        <a-input v-model="form.bankName" :maxLength="256" :placeholder="$t('请输入') + $t('银行名称')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('银行卡号')" prop="bankCardNo" >
        <a-input v-model="form.bankCardNo" :maxLength="128" :placeholder="$t('请输入') + $t('银行卡号')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('开户行')" prop="openBankName" >
        <a-input v-model="form.openBankName" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="routing number" prop="routingNumber" >
        <a-input v-model="form.routingNumber" :maxLength="64" :placeholder="$t('请输入')+'routing number'" />
      </a-form-model-item>
      <a-form-model-item label="swift code" prop="swiftCode" >
        <a-input v-model="form.swiftCode" :maxLength="32" :placeholder="$t('请输入')+'swift code'" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUserWithdrawalAccount, addUserWithdrawalAccount, updateUserWithdrawalAccount } from '@/api/user/withdrawalAccount'
import { pageUser } from '@/api/biz/user'

export default {
  name: 'CreateForm',
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      userFetching: false,
      userOptions: [],
      // 表单参数
      form: {
        id: null,
        userId: undefined,
        type: 'bank',
        realName: null,
        bankName: null,
        bankCardNo: null,
        openBankName: null,
        routingNumber: null,
        swiftCode: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: this.$t('请选择用户'), trigger: 'change' }
        ],
        type: [
          { required: true, message: this.$t('账户类型不能为空'), trigger: 'change' }
        ],
        realName: [
          { required: true, message: this.$t('持卡人姓名不能为空'), trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: this.$t('银行名称不能为空'), trigger: 'blur' }
        ],
        bankCardNo: [
          { required: true, message: this.$t('银行卡号不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: undefined,
        type: 'bank',
        realName: null,
        bankName: null,
        bankCardNo: null,
        openBankName: null,
        routingNumber: null,
        swiftCode: null
      }
      this.userOptions = []
    },
    /** 远程搜索用户 */
    fetchUser (value) {
      this.userFetching = true
      const param = { pageNum: 1, pageSize: 20 }
      if (value) {
        param.nickName = value
      }
      pageUser(param).then(res => {
        const records = (res.data && res.data.records) || []
        this.userOptions = records.map(u => ({
          value: u.id,
          label: u.nickName + (u.id ? '(' + u.id + ')' : '')
        }))
      }).finally(() => {
        this.userFetching = false
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : undefined
      getUserWithdrawalAccount(id).then(response => {
        this.form = response.data
        if (this.form.type === null || this.form.type === undefined) {
          this.form.type = 'bank'
        }
        if (response.data.userId) {
          this.userOptions = [{
            value: response.data.userId,
            label: (response.data.userNickname || '') + '(' + response.data.userId + ')'
          }]
        }
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const payload = { ...this.form }
          if (this.formType === 2) {
            updateUserWithdrawalAccount(payload).then(() => {
              this.$message.success(this.$t('修改成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addUserWithdrawalAccount(payload).then(() => {
              this.$message.success(this.$t('新增成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
